export const buildWorkSessionQueryKey = () => {
	return {
		all: ['workSession'] as const,
		proposed: ['workSession', 'proposed'] as const,
		active: ['workSession', 'active'] as const,
		step: ['workSession', 'step'] as const
	};
};
